// api
import type { WriteAccountDto } from '@/api/generated/recalc/endpoints/v1/accounts';

// relative
import type { CreateAccountFormValues } from './createAccountForm.schema';

export function toCreateAccountFormValues(): CreateAccountFormValues {
  return {
    name: '',
    address: '',
    billingAddress: '',
  };
}

export function toCreateAccountDto(
  values: CreateAccountFormValues,
): WriteAccountDto {
  return {
    Name: values.name,
    Address: values.address,
    BillingAddress: values.billingAddress,
  };
}
